import React from 'react';

const DataRow = (props) => {
  const data = props;
  return (
    <>
      <div className="row g-0 py-3">
        <div className="col-12 col-lg-4 my-1 my-lg-2">
          <div
            className="font-weight-bold fw-bold"
            style={{ color: 'rgba(57,90,119)' }}
          >
            {data.title}
            {
              data.required
                ? <i style={{ color: 'rgba(232,94,89)' }}>※</i>
                : ''
            }
          </div>
        </div>
        <div className="col-12 col-lg-8 my-1 my-lg-2">
          <input
            type="text"
            placeholder={data.placeholder ? data.placeholder : ''}
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            style={{
              lineHeight: '3',
              border: data.error ? '1px solid red' : 'none',
              width: '100%',
              backgroundColor: 'white',
              color: 'rgba(44,81,115)',
            }}
          />
          <span
            className="row g-0 mt-2 mx-2"
            style={{ color: '#ff0000', fontSize: '12px' }}
          >
            {data.error}
          </span>
        </div>
      </div>
    </>
  );
};
export default DataRow;
